var map = {
	"./api.js": "./src/store/modules/api.js",
	"./app.js": "./src/store/modules/app.js",
	"./pageCache.js": "./src/store/modules/pageCache.js",
	"./permission.js": "./src/store/modules/permission.js",
	"./recordsQuery.js": "./src/store/modules/recordsQuery.js",
	"./settings.js": "./src/store/modules/settings.js",
	"./tagsView.js": "./src/store/modules/tagsView.js",
	"./user.js": "./src/store/modules/user.js",
	"./videoListPlayback.js": "./src/store/modules/videoListPlayback.js"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./src/store/modules sync recursive \\.js$";